/* eslint-disable react/no-unescaped-entities */
import {
  commonMandatoryParams,
  commonOptionalParams,
  ParameterProps,
} from './common-params';
import { FormLayout } from '../../../quest/program-wizard/common';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  GridItem,
  SimpleGrid,
} from '@chakra-ui/react';
import { Select } from '@ssar-app/uikit';
import { Controller } from 'react-hook-form';

export const AccountManagementParams = (props: ParameterProps) => {
  const { errors, control } = props.formMethods;
  return (
    <>
      <FormLayout header='Mandatory Parameters'>
        <SimpleGrid columns={1} ml={10}>
          {commonMandatoryParams(props)}
          <Box>
            <FormControl
              isRequired
              isInvalid={!!errors.BureauCallIndicator}
              mb={6}
            >
              <Grid templateColumns='repeat(4,1fr)'>
                <GridItem justifyContent='end' display='flex'>
                  <FormLabel>BureauCallIndicator : </FormLabel>
                </GridItem>
                <GridItem colSpan={3}>
                  <Controller
                    name='BureauCallIndicator'
                    defaultValue={
                      props.model?.BureauCallIndicator ||
                      props.paramOptions.BureauCallIndOptions[1] ||
                      ''
                    }
                    control={control}
                    render={({ value, onChange }) => (
                      <Select
                        options={props.paramOptions.BureauCallIndOptions.map(
                          (val) => ({
                            label: val,
                            value: val,
                          }),
                        )}
                        defaultValue={value}
                        optionLabelProps={{ color: 'black' }}
                        selectContainerProps={{ width: 500 }}
                        onChange={(e) => {
                          onChange(e);
                          props.setModel({
                            ...props.model,
                            BureauCallIndicator: e as string,
                          });
                        }}
                      />
                    )}
                  ></Controller>
                  <FormErrorMessage>
                    {errors.BureauCallIndicator?.message}
                  </FormErrorMessage>
                  <FormHelperText fontSize='xs'>
                    Indicator for Bureau Call (Client deliver or not) Only for
                    Prod
                  </FormHelperText>
                </GridItem>
              </Grid>
            </FormControl>
          </Box>
        </SimpleGrid>
      </FormLayout>
      <FormLayout header='Optional Parameters'>
        <SimpleGrid columns={1}>
          {commonOptionalParams(props)}
          <Box>
            <FormControl isInvalid={!!errors.SerJsonValidate} mb={6}>
              <Grid templateColumns='repeat(4,1fr)'>
                <GridItem justifyContent='end' display='flex'>
                  <FormLabel>Validate the ser-json date : </FormLabel>
                </GridItem>
                <GridItem colSpan={3}>
                  <Controller
                    name='SerJsonValidate'
                    defaultValue={props.model?.SerJsonValidate || 'N'}
                    control={control}
                    render={({ value, onChange }) => (
                      <Select
                        options={['Y', 'N'].map((val) => ({
                          label: val,
                          value: val,
                        }))}
                        defaultValue={value}
                        optionLabelProps={{ color: 'black' }}
                        selectContainerProps={{ width: 250 }}
                        // placeholder='Y'
                        onChange={(e) => {
                          onChange(e);
                          props.setModel({
                            ...props.model,
                            SerJsonValidate: e as string,
                          });
                        }}
                      />
                    )}
                  ></Controller>
                  <FormErrorMessage>
                    {errors.SerJsonValidate?.message}
                  </FormErrorMessage>
                  <FormHelperText fontSize='xs'>
                    Validate ser-json date (Y/N). Note: validation available
                    when only when Bureau call type is 'P'.
                  </FormHelperText>
                </GridItem>
              </Grid>
            </FormControl>
          </Box>
        </SimpleGrid>
      </FormLayout>
    </>
  );
};
